/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Script from 'react-load-script';
import globals from '../../lib/globals/globals';
import logger from '../../lib/logger/logger';
import * as actions from '../../lib/store/tealium/actions';
import useSettings from '../hooks/use-settings';
import Foresee from '../foresee/Foresee';
import Nuance from '../nuance/Nuance';

var TealiumLoader = function TealiumLoader() {
  var dispatch = useDispatch();
  var utagUrl = useSelector(function (_ref) {
    var core = _ref.core;
    return core.tealium.utagUrl;
  });
  var tealiumLoaded = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.tealium.loaded;
  });

  var _globals = globals(),
      tmsSwitch = _globals.tmsSwitch,
      tmsWaitForAppReady = _globals.tmsWaitForAppReady;

  var _useSettings = useSettings(),
      applicationReady = _useSettings.applicationReady;

  useEffect(function () {
    if (!tealiumLoaded && tmsSwitch && globals().utagUrl) {
      if (!tmsWaitForAppReady || tmsWaitForAppReady && applicationReady) {
        utagUrl && logger.info('PERF: Loading Tealium');
        dispatch(actions.setTealiumUtagUrl(globals().utagUrl));
      }
    }
  }, [applicationReady, dispatch, tealiumLoaded, tmsSwitch, tmsWaitForAppReady, utagUrl]);

  var onLoad = function onLoad() {
    logger.info('Tealium loaded');
    dispatch(actions.setTealiumUtagLoaded());
  };

  var onError = function onError() {
    logger.error('Error loading tealium');
    dispatch(actions.setTealiumEnabled(false));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, utagUrl && /*#__PURE__*/React.createElement(Script, {
    url: utagUrl,
    onLoad: onLoad,
    onError: onError
  }), tealiumLoaded && /*#__PURE__*/React.createElement(Foresee, null), tealiumLoaded && /*#__PURE__*/React.createElement(Nuance, null));
};

export default TealiumLoader;